export function isYouTubeUrl(url: string): boolean {
  return /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com|youtu\.be)\/.+/.test(url);
}

export function getYouTubeEmbedUrl(url: string): string | null {
  const regExp =
    /^.*(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|v\/))([^#&?]*).*/;
  const match = url.match(regExp);
  return match && match[1].length === 11
    ? `https://www.youtube.com/embed/${match[1]}`
    : null;
}

export const getImageSrc = (img: string | File) =>
  typeof img === "string" ? img : URL.createObjectURL(img);
